<template>
  <section>
    <v-card height="240px" width="320px" outlined>
      <h5 v-if="!currentPicture">No Image</h5>
      <img v-else v-bind:src="currentPicture" alt="Captured Picture" />
    </v-card>
    <label for="camera">Take picture</label>
    <input ref="camera_input" type="file" name="camera" id="camera" accept="image/*;capture=camera" value="camera" v-on:change="onPhotoTaken()"/>
  </section>
</template>

<script>
export default {
  name: "CameraMobile",
  data () {
    return {
      currentPicture: "",
      pictures: []
    }
  },
  methods: {
    onPhotoTaken() {
      const input = this.$refs.camera_input;
      if (input.files && input.files[0]) {
        const reader = new FileReader;
        reader.onload = e => {
          this.pictures.push(e.target.result);
          this.currentPicture = e.target.result;
        }
        input.files.forEach(element => {
          reader.readAsDataURL(element);
        });
      }
    }
  }
}
</script>

<style scoped>

</style>